import { BaseEntity } from "./BaseEntity";
import { Training } from "./Training";

export class Typology extends BaseEntity {
    public name: string = "";
    public training?: string | Training = "";

    constructor(model: Partial<Typology> = {}) {
        super(model?.id);
        Object.assign(this, model);
    }
}

export type PTypology = Partial<Typology>;
